module.exports = __webpack_public_path__ + "static/media/birthday-cake.a6645a34.svg";